module.exports = __webpack_public_path__ + "static/media/ig-icon.2a8d4da2.png";